package com.ervasstudio.tracoemovimento.repository


import com.ervasstudio.tracoemovimento.model.Aluno
import com.ervasstudio.tracoemovimento.model.BlogPost
import com.ervasstudio.tracoemovimento.model.NewsLetterData
import com.ervasstudio.tracoemovimento.model.UserRecoveryData
import com.ervasstudio.tracoemovimento.model.VisitData
import com.ervasstudio.tracoemovimento.util.formatarDataHoraELocal
import io.ktor.client.*
import io.ktor.client.engine.js.* // Motor essencial para Kotlin/JS (Browser)
import io.ktor.client.call.*
import io.ktor.client.plugins.contentnegotiation.*
import io.ktor.client.request.*
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess
import io.ktor.serialization.kotlinx.json.*
import kotlinx.serialization.json.Json
import kotlin.io.encoding.Base64
import kotlin.io.encoding.ExperimentalEncodingApi

@OptIn(ExperimentalEncodingApi::class)
object BlogRepository {


    /*

        @OptIn(ExperimentalEncodingApi::class)
        suspend fun fetchFeaturedPost(): BlogPost? {
            return try {
                val credentials = Base64.encode("Fromel:IlcU aH6i bNl2 iAg0 dly4 Wtxr".encodeToByteArray())

                // Criamos o objeto de opções inteiramente em JS puro para evitar qualquer RequestInit do Kotlin
                val options = js("""({
                method: 'GET',
                headers: {
                    'Authorization': 'Basic ' + credentials,
                    'Accept': 'application/json'
                }
            })""")

                val response = window.fetch(
                    "https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/blog?destacado=true&limit=1&order_by=cct_created&order=desc",
                    options
                ).await()

                if (response.ok) {
                    val text = response.text().await()
                    val posts = Json { ignoreUnknownKeys = true }
                        .decodeFromString<List<BlogPost>>(text)
                    posts.firstOrNull()
                } else {
                    null
                }
            } catch (e: Exception) {
                console.log("ERRO ao recuperar destacado: ${e.message}")
                null
            }
        }

        @OptIn(ExperimentalEncodingApi::class)
        suspend fun fetchPosts(limite: Int = 20): List<BlogPost> {
            return try {
                val credentials = Base64.encode("Fromel:IlcU aH6i bNl2 iAg0 dly4 Wtxr".encodeToByteArray())

                val options = js("""({
                method: 'GET',
                headers: {
                    'Authorization': 'Basic ' + credentials,
                    'Accept': 'application/json'
                }
            })""")

                val response = window.fetch(
                    "https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/blog?limit=$limite&order_by=cct_created&order=desc",
                    options
                ).await()

                val text = response.text().await()
                Json { ignoreUnknownKeys = true }.decodeFromString<List<BlogPost>>(text)
            } catch (e: Exception) {
                console.log("ERRO: ${e.message}")
                emptyList()
            }
        }
    */





    // Configura o cliente Ktor uma única vez (reutilizável e performático)
    @OptIn(ExperimentalEncodingApi::class)
    private val httpClient = HttpClient(Js) {
        install(ContentNegotiation) {
            json(Json {
                ignoreUnknownKeys = true
                isLenient = true
            })
        }
    }

    @OptIn(ExperimentalEncodingApi::class)
    private fun getAuthHeader(): String {
        val credentials = Base64.encode("Fromel:IlcU aH6i bNl2 iAg0 dly4 Wtxr".encodeToByteArray())
        return "Basic $credentials"
    }

    suspend fun fetchFeaturedPost(): BlogPost? {
        return try {
            // O Ktor faz a requisição e já desserializa direto para List<BlogPost>!
            val posts: List<BlogPost> =
                httpClient.get("https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/blog") {
                    parameter("destacado", "true")
                    parameter("limit", "1")
                    parameter("order_by", "cct_created")
                    parameter("order", "desc")
                    headers.append(HttpHeaders.Authorization, getAuthHeader())
                    headers.append(HttpHeaders.Accept, "application/json")
                }.body()

            posts.firstOrNull()
        } catch (e: Exception) {
            console.log("ERRO ao recuperar destacado: ${e.message}")
            null
        }
    }

    suspend fun fetchPostById(postId: String): BlogPost? {
        return try {
            // O ID vai direto na URL, conforme a documentação do JetEngine CCT
            val post: BlogPost = httpClient.get("https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/blog/$postId") {
                headers.append(HttpHeaders.Authorization, getAuthHeader())
                headers.append(HttpHeaders.Accept, "application/json")
            }.body()

            post
        } catch (e: Exception) {
            console.log("ERRO ao recuperar post por ID ($postId): ${e.message}")
            null
        }
    }

    suspend fun fetchPosts(limite: Int = 20): List<BlogPost> {
        return try {
            // Mesma coisa aqui, limpo e sem precisar lidar com JSON.decodeFromString manual
            httpClient.get("https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/blog") {
                parameter("limit", limite)
                parameter("order_by", "cct_created")
                parameter("order", "desc")
                headers.append(HttpHeaders.Authorization, getAuthHeader())
                headers.append(HttpHeaders.Accept, "application/json")
            }.body()
        } catch (e: Exception) {
            console.log("ERRO: ${e.message}")
            emptyList()
        }
    }


    // 1. Enviar dados de recuperação
    suspend fun sendRecoveryData(userData: UserRecoveryData): Boolean {
        return try {
            val response = httpClient.post("https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/emailscurso") {
                headers.append(HttpHeaders.Authorization, getAuthHeader())
                headers.append(HttpHeaders.Accept, "application/json")
                headers.append(HttpHeaders.ContentType, "application/json") // <--- ADICIONADO AQUI
                setBody(userData)
            }

            if (response.status.isSuccess()) {
                console.log("Dados enviados com sucesso!")
                true
            } else {
                console.log("Erro na resposta da API: ${response.status.description}")
                false
            }
        } catch (e: Exception) {
            console.log("ERRO ao enviar: ${e.message}")
            false
        }
    }

    // 2. Salvar novo e-mail na base de notícias
    suspend fun saveNewsEmail(email: String): Boolean {
        return try {
            val response = httpClient.post("https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/emailsnoticias") {
                headers.append(HttpHeaders.Authorization, getAuthHeader())
                headers.append(HttpHeaders.Accept, "application/json")
                headers.append(HttpHeaders.ContentType, "application/json") // <--- ADICIONADO AQUI
                setBody(NewsLetterData(email))
            }
            response.status.isSuccess()
        } catch (e: Exception) {
            console.log("Erro ao salvar e-mail: ${e.message}")
            false
        }
    }

    // 3. Registrar visita na página
    suspend fun registerVisit(): Boolean {
        return try {
            val visitPayload = VisitData(
                visita = formatarDataHoraELocal()
            )

            val response = httpClient.post("https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/visitas") {
                headers.append(HttpHeaders.Authorization, getAuthHeader())
                headers.append(HttpHeaders.Accept, "application/json")
                setBody(visitPayload)
            }

            if (response.status.isSuccess()) {
                console.log("Visita registrada com sucesso na página")
                true
            } else {
                console.log("Erro ao registrar visita: ${response.status.value} - ${response.status.description}")
                false
            }
        } catch (e: Exception) {
            console.log("ERRO ao registrar visita: ${e.message}")
            false
        }
    }

    // 4. Verificar se o e-mail de notícias já existe
    suspend fun checkNewsEmailExists(email: String): Boolean {
        return try {
            val text: String = httpClient.get("https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/emailsnoticias") {
                parameter("email", email)
                headers.append(HttpHeaders.Authorization, getAuthHeader())
                headers.append(HttpHeaders.Accept, "application/json")
            }.body()

            text.contains("\"email\":\"$email\"") || text.trim() != "[]"
        } catch (e: Exception) {
            console.log("Erro ao checar e-mail: ${e.message}")
            false
        }
    }

    // 4. Verificar se o e-mail de notícias já existe
    suspend fun checkEmailAlunoExists(email: String): Boolean {
        return try {
            val text: String = httpClient.get("https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/aluno") {
                parameter("email", email)
                headers.append(HttpHeaders.Authorization, getAuthHeader())
                headers.append(HttpHeaders.Accept, "application/json")
            }.body()

            text.contains("\"email\":\"$email\"") || text.trim() != "[]"
        } catch (e: Exception) {
            console.log("Erro ao checar e-mail: ${e.message}")
            false
        }
    }


    suspend fun getAlunoByEmail(email: String): Aluno? {
        return try {
            // O JetEngine CCT retorna uma lista de objetos filtrados por query parameter
            val alunos: List<Aluno> = httpClient.get("https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/aluno") {
                parameter("email", email)
                headers.append(HttpHeaders.Authorization, getAuthHeader())
                headers.append(HttpHeaders.Accept, "application/json")
            }.body()

            // Retorna o primeiro aluno encontrado ou null se a lista vier vazia ([])
            alunos.firstOrNull()
        } catch (e: Exception) {
            console.log("Erro ao buscar aluno por e-mail: ${e.message}")
            null
        }
    }


    suspend fun sendNewAluno(aluno: Aluno): Boolean {
        return try {
            val response = httpClient.post("https://apitracoemovimento.ervasstudio.com/wp-json/jet-cct/aluno") {
                headers.append(HttpHeaders.Authorization, getAuthHeader())
                headers.append(HttpHeaders.Accept, "application/json")
                headers.append(HttpHeaders.ContentType, "application/json") // <--- ADICIONADO AQUI
                setBody(aluno)
            }

            if (response.status.isSuccess()) {
                console.log("Aluno cadastrado com sucesso!")
                true
            } else {
                console.log("Erro na resposta da API: ${response.status.description}")
                false
            }
        } catch (e: Exception) {
            console.log("ERRO ao cadastrat: ${e.message}")
            false
        }
    }

}